<script>
import util from "@/libs/util";
import { validatePass,validatePhoneNumber,validateEmail } from "@/common/validate";

export default {
  name: "set_pwd_page",
  data() {
    // 验证 不同的验证方式 手机号有手机号的规则 邮箱有邮箱的规则
    const validateValidateWay = (rule, value, callback)=>{
      if (!value) {
        callback(new Error(this.$t("l."+(this.radio.value == "1"?"remark3":"remark03"))));
      } else {
        if(this.radio.value == "1"){   // 手机号
            if(!validatePhoneNumber(value)){
              callback(new Error(this.$t("l.remark91")));
            }else{
              callback();
            }
        }else{    //  邮箱
          console.log("验证邮箱");
          if(!validateEmail(value)){
            callback(new Error(this.$t("l.remark14")));
          }else{
            callback();
          }
        }
      }
    }
    return {
      form: {
        mobile: "",
        captcha: "",
        username: "",
        password: "",
        again_password:"",
      },
      radio:{
        value:"1",
        validateWay:'mobile'
      },
      start: this.$t('l.get_captcha'),
      isVerificationShow: false,
      puzzleSpin:false,
      isVerificationShowForSubmit:false,
      loading:false,
      puzzleImgList: [
        "/images/banner/banner1.jpg",
        "/images/banner/banner3.jpg",
      ],
      rules: {
        mobile: [
          {validator: validateValidateWay, trigger: 'blur', required: true}
        ],
        captcha: [
          {required: true, message: '验证码必填', trigger: 'blur'}
        ],
        username: [
          {required: true, message: '用户名必填', trigger: 'blur'}
        ],
        password: [
          {validator: validatePass, trigger: 'blur', required: true}
        ],
        again_password: [
          {validator: validatePass, trigger: 'blur', required: true}
        ],
        // oldpassword:[
        //   {required: true, message: '原密码必填', trigger: 'blur'}
        // ]
      },
      showPwdContent:false,
      passwordType:"password"
    }
  },
  methods: {
    getCaptcha() {
      // 需要验证是否是人
      if (!this.form.mobile) {
        this.$Message.error(this.$t('l.remark3'))
        return
      }
      this.isVerificationShow = true;
    },
    handleSuccess() {
      this.puzzleSpin = true;
      util.ajax.get('/captcha', {
        params: {
          data: {
            company: "【" + this.$t('l.dty_platform') + "】",
            mobile: this.form.mobile,
            type:this.radio.value,
            language: localStorage.getItem('language')
          }
        }
      }).then(res => {
        this.puzzleSpin = false;
        this.isVerificationShow = false;
        if (!res.code) {
          this.start = 60;
          this.$Message.success(this.$t('l.hint4'));
          var timer = setInterval(() => {
            if (this.start == 0) {
              clearInterval(timer)
              this.start = this.$t('l.get_captcha');
            } else {
              this.start--;
            }
          }, 1000)
        }
      })
    },

    // 提交
    handleSuccessForSubmit(){
      this.isVerificationShowForSubmit = false;
      util.ajax.post('/updatePassword', {
          username: this.form.username,
          password: this.form.password,
          mobile:this.form.mobile,
         type:this.radio.value,
          captcha:this.form.captcha,
          // oldpassword:this.form.oldpassword
      }).then((res) => {
        if(!res.code){
          this.$Message.success({
            top: 50,
            duration: 2,
            content:"操作成功，2秒后自动跳转"
          });
          setTimeout(()=>{
            this.$router.push({
              name: 'home_index'
            });
          },2000)
        }
      }).catch(e => {
      }).finally(()=>{
        this.loading = false;
      });
    },

    handleOnError() {
      this.$Message.error("验证失败，请重试")
    },
    changeShowPwd() {
      this.showPwdContent = !this.showPwdContent;
      this.passwordType = this.showPwdContent ?"text":"password";
    },

    // 提交表单
    submit(){
      // 验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 判断两次密码 是否一致
          if(this.form.password != this.form.again_password){
            this.$Message.error("两次密码输入不一致");
          }else{
            this.loading = true;
            this.isVerificationShowForSubmit = true;
            this.handleSuccessForSubmit();
          }
        }else{

        }
      });
    },
    goLogin(){
      localStorage.removeItem("token");
      this.$router.push({
        name: 'login'
      });
    },
    changeRadio(val){
      this.form.mobile = "";
      // this.$refs["form"].resetFields();
    }


  },
  mounted() {
    util.ajax.get('/getuser', {params: {refresh:  0}}).then((res) => {
      let user = res.data;
      if (user){
        console.log(user);
        this.form.username =  user.username;
      }
    }).catch(err => {

    });
  }
}
</script>

<template>
  <div class="container">
    <Row class="form-con-row" type="flex" justify="center">
      <Col>
        <!-- 重设密码 -->
        <h2>{{$t("l.remark240")}}</h2>
        <p style="text-align: center;margin: 10px 0;color: #e7103b">* {{$t("l.remark241")}}</p>
      </Col>
    </Row>
    <div class="login-con">
      <div class="form-con">
        <Row class="form-con-row" type="flex" justify="center">
          <Col>
            <h3>{{$t("l.new_pwd_set")}}</h3>
          </Col>
        </Row>
        <template>
          <Row class="form-con-row" type="flex" justify="center" style="margin-top: 20px">
            <Col>
              <!-- 重设密码 -->
              <Form :rules="rules" label-position="top" ref="form" :model="form"
                    class="form-con-form forget-form">
                <FormItem :label="$t('l.'+(radio.value =='1'?'mobile':'e_mail'))" prop="mobile" class="FormItem">
                  <Row :gutter="10">
                    <Col span="14">
                      <Input class="form-input" type="text" v-model="form.mobile" autocomplete="off" :placeholder="$t('l.'+(radio.value =='1'?'remark3':'remark03'))"/>
                    </Col>
                    <Col span="10">
                      <RadioGroup @on-change="changeRadio" v-model="radio.value" style="display: flex">
                        <Radio label="1" value="1">手机号验证</Radio>
                        <Radio label="2" value="2">邮箱验证</Radio>
                      </RadioGroup>
                    </Col>
                  </Row>
                </FormItem>
                <FormItem :label="$t('l.captcha')" prop="captcha" class="FormItem">
                  <div class="form-con-form-div">
                    <Row :gutter="10">
                      <Col span="14">
                        <Input class="input-captcha" type="text" v-model="form.captcha" autocomplete="off" :placeholder="$t('l.remark4')"/>
                      </Col>
                      <Col span="10">
                        <Button :style="{backgroundColor:start!=$t('l.get_captcha')?'#aaa':'#5e30c3'}"
                                :disabled="start!=$t('l.get_captcha') || isVerificationShow"  class="button-captcha" type="info"
                                long @click="getCaptcha">{{ start }}
                        </Button>
                      </Col>
                    </Row>
                    <Row>
                      <span style="font-size: 12px;color: red;">{{$t("l.remark239")}}</span>
                    </Row>
                  </div>
                </FormItem>
                <FormItem :label="$t('l.username')" prop="username" class="FormItem">
                  <Input disabled type="text" class="form-input" v-model="form.username" :placeholder="$t('l.remark')"/>
                </FormItem>
<!--                <FormItem label="原始密码" prop="oldpassword" class="FormItem">-->
<!--                  <Input type="password" class="form-input" autocomplete="off" v-model="form.oldpassword" placeholder="请填写原密码"/>-->
<!--                </FormItem>-->
                <FormItem :label="$t('l.password')" prop="password" class="FormItem">
                  <Input ref="password" autocomplete="off" :type="passwordType" class="form-input"
                         v-model="form.password" :placeholder="$t('l.remark2')" >
                    <span @click="changeShowPwd" slot="suffix">
                      <template v-if="showPwdContent">
                            <Icon type="ios-eye" />
                      </template>
                      <template v-else>
                            <Icon type="ios-eye-off" />
                      </template>
                    </span>
                  </Input>
                </FormItem>
                <FormItem label="确认密码" prop="password" class="FormItem">
                  <Input ref="password"  autocomplete="off" :type="passwordType" class="form-input"
                         v-model="form.again_password" placeholder="请再次填写密码" >
                    <span @click="changeShowPwd" slot="suffix">
                      <template v-if="showPwdContent">
                            <Icon type="ios-eye" />
                      </template>
                      <template v-else>
                            <Icon type="ios-eye-off" />
                      </template>
                    </span>
                  </Input>
                </FormItem>
              </Form>
            </Col>
          </Row>
        </template>
        <Row type="flex" justify="center" style="padding: 10px 20px;margin-top: 20px">
          <Col>
            <Button type="primary" :loading="loading" :disabled="loading || isVerificationShowForSubmit" @click="submit">提交</Button>
          </Col>
          <Col>
            <Button class="margin-left-10" type="primary" @click="goLogin">返回登录</Button>
          </Col>
        </Row>
      </div>
    </div>

    <div class="puzzle-box">
      <puzzleVerification :puzzleImgList="puzzleImgList" v-model="isVerificationShow" :onSuccess="handleSuccess"
                          :on-error="handleOnError" blockType="puzzle"></puzzleVerification>
      <Spin fix v-if="puzzleSpin" style="z-index: 999999" class="full"></Spin>
    </div>

<!--    <div class="puzzle-box">-->
<!--      <puzzleVerification :puzzleImgList="puzzleImgList" v-model="isVerificationShowForSubmit" :onSuccess="handleSuccessForSubmit"-->
<!--                          :on-error="handleOnError" blockType="puzzle"></puzzleVerification>-->
<!--    </div>-->

  </div>
</template>

<style scoped lang="less">
.container{
  height: 100%;
  padding: 0 10px;
}

.puzzle-box {
  position: relative;
  z-index: 8888;
  display: flex;
  justify-content: center;
  bottom: 35vh;
}

.form-con {
  margin: 40px 0;
}
</style>